/* kitsters-default-sort.js - force Best selling as the default sort on
   /collections/all.

   Loaded render-blocking from <head> in layout/theme.liquid, and ONLY on
   /collections/all when the URL carries no sort_by parameter (see the comment
   block there for why this cannot be done server-side). Because the gate is in
   Liquid and the redirect always adds sort_by, this file is never served for a
   request it would not redirect - so it can never loop, and it never delays a
   page it leaves alone.

   Deliberately no URL/URLSearchParams: this runs before anything else on the
   page and string concatenation is both faster and safe on every browser.
   Every existing parameter (facet filters, page) is preserved. */
(function () {
  var search = window.location.search;

  /* Belt-and-braces: the Liquid gate already guarantees this, but a cached or
     hand-edited URL must never bounce. */
  if (search.indexOf('sort_by=') !== -1) return;

  var target =
    window.location.pathname +
    search +
    (search ? '&' : '?') +
    'sort_by=best-selling' +
    window.location.hash;

  /* replace(), not assign() - the unsorted URL must not sit in history, or the
     back button lands on a page that immediately redirects forward again. */
  window.location.replace(target);
})();
